(function () {
    angular
    .module('meanApp')
    .filter('firstLetter', function() {
        return function(x) {
            if(!x) {
                return x;
            }
            x = x.toUpperCase();
            return x.charAt(0) || '';
        };
    })
    .filter('capitalizeFirst', function() {
        return function(x) {
            if(!x) {
                return x;
            }
            x = x.toLowerCase();
            return x.charAt(0).toUpperCase() + x.slice(1);
        };
    })
    .filter('roundToDecimal', function() {
        return function(x) {
            console.log('into decimal filter', x);
            if(!x) {
                return x;
            }
            x = parseFloat(x);
            x = (Math.round( x * 10 ) / 10)+'';
            x = x.replace('.', ',');

            return x;
        };
    });
})();
